import React from 'react';
import { Box, Grid } from '@mui/material';

import { Typography, Card, CardHeader, CardContent } from '@occc/ui-design-system';
import { MarketingContentFragment } from '@occc/graphql';

import { CustomTooltip } from './CustomTooltip';
import { MarketingContentData } from './MarketingContentData';
import { MarketingContentPreview } from './MarketingContentPreview';

import { FormSelect, Option } from '../../../components/FormSelect';

interface IMarketingContentProps {
  selectedMarketingContent: MarketingContentFragment;
  options: Option[];
  onChange: (event: React.ChangeEvent<{ value: string }>) => void;
  value: string;
}

export const MarketingContent: React.FC<IMarketingContentProps> = ({
  selectedMarketingContent,
  options,
  onChange,
  value,
}) => {
  return (
    <Card>
      <CardHeader
        title={
          <Box display='flex' justifyContent='space-between'>
            <Typography variant='h6' component='h4' display='flex' alignItems='center'>
              Marketing Content
              <CustomTooltip
                title='good to know'
                description='This is just a representation of the Marketing Content and does not reflect the exact look and feel of the current Offer inside your application.'
              />
            </Typography>
            <FormSelect
              options={options}
              value={value}
              onChange={onChange}
              sx={{ minWidth: 100 }}
              fullWidth={false}
              margin='none'
              label='Locale'
            />
          </Box>
        }
      />
      <CardContent>
        <Grid container={true} spacing={2}>
          <Grid item={true} md={6}>
            <MarketingContentData marketingContent={selectedMarketingContent} />
          </Grid>
          <Grid item={true} md={6}>
            <MarketingContentPreview marketingContent={selectedMarketingContent} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
